/**
 * @Author: v_jppjpeng
 * @Date: 2024-11-07 15:10:35
 * @Explain: 公共类上报
 */
export default {
  /** 请求超过5s */
  10: 'apiRequestExceeds5s',
  /** 请求异常 */
  11: 'apiRequestError',
};
